import { render, staticRenderFns } from "./WorkOrderHistory.vue?vue&type=template&id=15c98a4a&scoped=true"
import script from "./WorkOrderHistory.vue?vue&type=script&lang=js"
export * from "./WorkOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c98a4a",
  null
  
)

export default component.exports